import { render, staticRenderFns } from "./TableViewingArhive.vue?vue&type=template&id=7eba6b9e&scoped=true&"
import script from "./TableViewingArhive.vue?vue&type=script&lang=js&"
export * from "./TableViewingArhive.vue?vue&type=script&lang=js&"
import style0 from "./TableViewingArhive.vue?vue&type=style&index=0&id=7eba6b9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eba6b9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VPagination,VTextField})
